// Text constants for QuotesFallbackView component
const fallbackViewTexts = {
  cardTitle: 'Plan Your Next Job With Quotes, the collaborative planning tool.',
  benefits: [
    'Save Time Sourcing Jobs',
    'Lock in Pricing for 7 Days',
    'Share Quotes with Customers'
  ],
  imageAlt: 'Placeholder image',
  learnMoreText: 'Learn More',
  imageUrl: 'https://dam.thdstatic.com/content/production/q7k5j90tEwVD1kPkixSQQQ/'
  + 'OkRd7qOTw_7UpErTtyrMew/Original%20file/WF-6260106-AccountQuotes-Hero.jpg',
};

export default fallbackViewTexts;
